import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import styled from 'styled-components';
import { MuiThemeProvider } from '@material-ui/core/styles';
import { lightTheme } from 'theme';
import Typography from '@material-ui/core/Typography';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import { ResponsiveCardImg } from 'components/ResponsiveImg';

import ContentTypography from 'components/ContentTypography';

const StyledCard = styled(Card)`
  width: 100%;
  display: flex;
  transition: all 0.15s ease-in-out;

  &:hover {
    box-shadow: 0 4px 25px 0 rgba(0, 0, 0, 0.15);
  }
`;

const ResourceLink = styled(Link)`
  width: 100%;
  text-decoration: none;
  display: flex;
  flex-direction: column;
`;

const ResourceCardContent = styled(CardContent)`
  padding-top: 40px;
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  &:last-child {
    padding-bottom: 40px;
  }
`;

const ResourceMeta = styled(Typography)`
  margin-top: auto;
  padding-top: 30px;
  span {
    margin-right: 20px;
  }
`;

const ResourceCardImg = styled(ResponsiveCardImg)`
  padding-top: 75%;
`;

class ResourceCard extends React.PureComponent {
  render() {
    const { resource, hideDescription } = this.props;

    return (
      <MuiThemeProvider theme={lightTheme}>
        <StyledCard>
          <ResourceLink to={resource.url}>
            {resource.main_image && (
              <ResourceCardImg
                src={resource.main_image.url}
                alt="Resource Image"
                maxWidth={1200}
              />
            )}
            <ResourceCardContent>
              <Typography gutterBottom variant="h3" component="h2">
                {resource.title}
              </Typography>

              {!hideDescription && (
                <ContentTypography
                  variant="body2"
                  dangerouslySetInnerHTML={{
                    __html: resource.description
                  }}
                />
              )}

              <ResourceMeta variant="overline">
                {resource.resource_type}
              </ResourceMeta>
            </ResourceCardContent>
          </ResourceLink>
        </StyledCard>
      </MuiThemeProvider>
    );
  }
}

ResourceCard.propTypes = {
  resource: PropTypes.object.isRequired
};

export default ResourceCard;
